import AsyncStorage from "@react-native-async-storage/async-storage";
import { setCurrentGuestDetails, setGotGuestDetailsResponse, setGuestDetailsList } from "../Reducers/guestDetailsReducer";
import { clientConfigPath, current_client_config, currentIP } from "../../config/Constant";
import { setInitAppLogout, setIsLoggedIn, setLoggedInRoomNumber } from "../Reducers/appConfigReducer";
import { parseToGlobalDate } from "../../js/utility";

export const fetchGuestDetails = () => {

    return async (dispatch) => {

        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const DeviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');
        let room = await AsyncStorage.getItem('room');
        let roomID = await AsyncStorage.getItem('roomID');
        let guestToken = await AsyncStorage.getItem('guestToken');
        console.log("guestDetails - sessionToken:", sessionToken, "DeviceIdentifier:", DeviceIdentifier, "room:", room, "roomID: ", roomID, "guestToken:", guestToken);


        try {

            let header;
            if (roomID) {
                header = {
                    "sessionToken": sessionToken
                };
            } else {
                header = {
                    "sessionToken": sessionToken,
                    "guestToken": guestToken
                };
            }

            const response = await clientConfigPath.post(
                '/guestDetails/fetch' + `?dId=${DeviceIdentifier}&rn=${room}`,
                {
                    "payload": {},
                    "header": header
                }
            );

            console.log('API Response GUEST DETAILS:', response.data);

            const statusCode = response?.data?.header?.status?.code;
            if (statusCode === "SUCCESS") {
                const guestDetails = response?.data?.payload?.guestDetails;

                // Call guestReservation API
                if(guestDetails.guestToken && guestDetails.guestToken != ""){
                    dispatch(fetchGuestList(guestDetails));
                } else {
                    if(guestToken && guestToken != ""){
                        dispatch(setInitAppLogout(true));
                    } else {
                        dispatch(setGotGuestDetailsResponse(true));
                    }
                }
            } else {
                dispatch(setGotGuestDetailsResponse(true));
                console.log("ERROR FETCH GUEST DETAILS RESPONSE");
            }
        } catch (error) {
            dispatch(setGotGuestDetailsResponse(true));
            console.log('ERROR FETCH GUEST DETAILS RESPONSE:', error.message);

            if (error?.response?.status == 401) {
                dispatch(setInitAppLogout(true));
            }
        }
    };
};



export const fetchGuestList = (guestDetails) => {


    return async (dispatch, getState) => {

        try {

            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const DeviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');
            let room = await AsyncStorage.getItem('room');
            console.log(sessionToken, DeviceIdentifier, room, guestDetails.guestToken);

            const response = await clientConfigPath.post('/checkInGuestList/fetch' + `?dId=${DeviceIdentifier}&rn=${room}`,

                {
                    "payload": {},
                    "header": {
                        "locationId": guestDetails.locationId,
                        "guestToken": guestDetails.guestToken
                    }
                }

            );
            console.log('API Response guestReservation:', response.data);

            const statusCode = response?.data?.header?.status?.code;
            dispatch(setGotGuestDetailsResponse(true));
            
            if (statusCode === "SUCCESS") {

                const guestDetailsList = response.data?.payload?.guestDetails;
                let parsedGuestDetailsList = guestDetailsList.map(currentGuest=> parseToGlobalDate(currentGuest))
                dispatch(setGuestDetailsList(parsedGuestDetailsList));
                await AsyncStorage.setItem("current_guest_list", JSON.stringify(parsedGuestDetailsList));

                const currentGuestDetails = guestDetailsList.find(guestData => guestData.guestToken == guestDetails.guestToken);
                const parsedCurrentGuestDetails = parseToGlobalDate(currentGuestDetails)
                console.log("Current guest: ", parsedCurrentGuestDetails)

                dispatch(setCurrentGuestDetails(parsedCurrentGuestDetails))
                await AsyncStorage.setItem("current_guest_details", JSON.stringify(parsedCurrentGuestDetails));

                const tableReservationClientId = currentGuestDetails.clientId
                if (tableReservationClientId) {
                    await AsyncStorage.setItem('tableReservationClientId', tableReservationClientId);
                }

                let roomLocationName = response.data?.payload?.locationName;
                await AsyncStorage.setItem("room", roomLocationName);
                dispatch(setLoggedInRoomNumber(roomLocationName));
                dispatch(setIsLoggedIn(true));
            } else {
                console.log("ERROR FETCHING GUEST LIST DETAILS");

                if (response.status == 401) {
                    dispatch(setInitAppLogout(true));
                }
            }
        } catch (error) {
            console.log("ERROR FETCHING GUEST LIST DETAILS");
        }
    };
};
